<template>
  <!--  <div class="card-mesin-snap-list" @click="!$route.query.idconsole ? moreAction(idMesin):''">-->
  <div
    class="card-mesin-snap-list col-md-6"
    @click="!$route.query.idconsole ? $emit('moreAction') : ''"
  >
    <div class="card-mesin-header" v-if="connection.data">
      <div
        v-if="connection.data[idMesin] !== null"
        class="container-card-header"
        :class="{
          'bg-good': connection.data[idMesin].rssi >= -67,
          'bg-ok': connection.data[idMesin].rssi < -67,
          'bg-bad': !ol || connection.data[idMesin].rssi <= -80,
        }"
      >
        <div class="item-header-card-mesin">
          <img
            src="@/assets/icons/wifi-4-bar.svg"
            v-if="ol && connection.data[idMesin].rssi >= -30"
            alt=""
          />
          <img
            src="@/assets/icons/wifi-3-bar.svg"
            v-else-if="ol && connection.data[idMesin].rssi >= -67"
            alt=""
          />
          <img
            src="@/assets/icons/wifi-2-bar.svg"
            v-else-if="ol && connection.data[idMesin].rssi >= -70"
            alt=""
          />
          <img
            src="@/assets/icons/wifi-1-bar.svg"
            v-else-if="ol && connection.data[idMesin].rssi >= -80"
            alt=""
          />
          <img src="@/assets/icons/wifi-off.svg" v-if="!ol" alt="" />

          <div class="f-c-midgrey f-12 m-l-8" v-if="ol">
            {{ connection.data[idMesin].ssid }}
          </div>
          <div class="f-c-red f-12 m-l-8" v-else>Offline</div>
        </div>
        <div
          class="item-header-card-mesin"
          v-if="connection.data[idMesin].rssi < -67"
        >
          <div class="f-c-midgrey f-12 m-r-8">Sinyal lemah</div>
          <img src="@/assets/icons/alert-circle-gray.svg" alt="" />
        </div>
      </div>

      <div v-else class="container-card-header bg-bad">
        <div class="item-header-card-mesin">
          <img src="@/assets/icons/wifi-off.svg" alt="" />
          <div class="f-c-red f-12 m-l-8">Offline</div>
        </div>
      </div>
    </div>

    <div
      class="card-mesin-header container-card-header ph-item mb-0 bg-good"
      v-else
    >
      <div class="ph-col-6 p-0">
        <div class="ph-row m-0">
          <div class="ph-col-2 big mr-2 mb-0"></div>
          <div class="ph-col-8 big mb-0"></div>
        </div>
      </div>
      <div class="ph-col-6 p-0">
        <div class="ph-row m-0 justify-content-end">
          <div class="ph-col-8 big mb-0"></div>
        </div>
      </div>
    </div>

    <!-- BODY -->
    <div class="card-mesin-body">
      <div class="item-card-mesin-body">
        <div class="f-c-midgrey f-16 - f-semi" v-if="!searchKey">
          {{ nama }}
        </div>
        <div
          class="f-c-black f-16 - f-semi"
          v-else
          v-html="searchHighlight(nama, searchKey)"
        ></div>
        <img
          v-if="!$route.query.idconsole"
          src="@/assets/icons/more-horizontal-grey.svg"
          alt=""
        />
      </div>
      <div class="item-card-mesin-body mt-1">
        <div class="d-flex align-items-center">
          <img
            src="@/assets/icons/mesin.svg"
            alt=""
            class="m-r-4"
            style="height: 16px"
          />
          <div class="f-regular f-13 f-c-midgrey m-r-8" v-if="jenis === 1">
            Mesin Cuci ({{urutan}})
          </div>
          <div class="f-regular f-13 f-c-midgrey m-r-8" v-else>
            Mesin Pengering  ({{urutan}})
          </div>
        </div>
        <div class="d-flex align-items-center">
          <img
            src="@/assets/icons/bookmark.svg"
            alt=""
            class="m-r-4"
            style="height: 16px"
          />
          <div class="f-regular f-13 f-c-midgrey m-r-8">{{ kategori }}</div>
        </div>
      </div>
      <div class="item-card-mesin-body mt-1">
        <div class="f-13 f-c-midgrey" v-if="!isSearch">ID: {{ idMesin }}</div>
        <div
          class="f-13 f-c-black"
          v-else
          v-html="searchHighlight(idMesin, searchKey)"
        ></div>
        <div
          class="card-mesin-gray-frame f-c-midgrey f-13"
          v-if="firmWare && firmWare.version > ver && ol"
        >
          Update Firmware
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-mesin-footer">
      <div class="footer-item f-c-midgrey f-13" v-if="sw && ol">
        <span class="f-c-green">Berjalan</span> •
        {{
          aid === "BOS" || aid === ""
            ? "SmartOwner"
            : !aid.includes("$")
            ? aid
            : layananAid.data.idtransaksi
        }} 
      </div>
      <div class="footer-item f-c-midgrey f-13" v-else-if="!sw && ol">
        Standby • <span class="f-c-red">Tidak menyala</span>
      </div>
      <div class="footer-item f-c-midgrey f-13" v-else-if="!ol">
        Tidak terhubung
      </div>
      <div class="footer-item-running" v-if="sw">
        <div class="f-c-midgrey f-13" v-if="aid === 'BOS' || aid === ''">
          Dinyalakan manual oleh <b>owner</b>.
        </div>
        <template v-else>
          <div class="f-c-midgrey f-13" v-if="layananAid.data">
            <span v-if="!aid.includes('$')">{{ layananAid.data.nama }}</span>
            <span v-else>{{ layananAid.data.layanan.nama_layanan }}</span>
          </div>
          <div class="ph-item col-8 p-0 m-0" v-else>
            <div class="ph-col-8 p-0 m-0">
              <div class="ph-row m-0">
                <div class="ph-col-12 big mb-0"></div>
              </div>
            </div>
          </div>
        </template>
        <div class="card-mesin-gray-frame f-c-midgrey f-13">
          {{ this.formatMilisecond(time) }}
        </div>
      </div>
    </div>

    <div class="more-menu-card" v-if="moreMenu === idMesin">
      <div class="more-menu-item" @click="toDetailMesin" v-if="validateAccess('snapBridge.read')">
        <img class="icon-more-item" src="@/assets/icons/file-text.svg" alt="" />
        <div class="text-content f-regular f-16 f-c-black">Detail</div>
      </div>
      <div class="more-menu-item" @click="toEdit" v-if="validateAccess('snapBridge.update')">
        <img class="icon-more-item" src="@/assets/icons/edit_2.svg" alt="" />
        <div class="text-content f-regular f-16 f-c-black">Ubah</div>
      </div>
      <div class="more-menu-item" v-if="ol && validateAccess('snapBridge.update')">
        <div class="d-flex" @click="$emit('turnOffMesin')" v-if="sw">
          <img class="icon-more-item" src="@/assets/icons/power.svg" alt="" />
          <div class="text-content f-regular f-16 f-c-red">Matikan Mesin</div>
        </div>
        <div class="d-flex" @click="$emit('turnOnMesin')" v-else>
          <img
            class="icon-more-item"
            src="@/assets/icons/power-green.svg"
            alt=""
            style="width: 24px; height: 24px"
          />
          <div class="text-content f-regular f-16 f-c-green">
            Nyalakan Mesin
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Countdown from "@/component-items/Countdown";
import { mapGetters } from "vuex";
import router from "@/router";

export default {
  name: "SOCardSnapMesin",
  components: { Countdown },
  props: [
    "ssid",
    "nama",
    "jenis",
    "kategori",
    "idMesin",
	"urutan",
    "tl",
    "ol",
    "sw",
    "aid",
    "ver",

    "connection",
    "firmWare",
    "isSearch",
    "searchKey",

    "moreMenu",
  ],
  data() {
    return {
      more: false,
      time: 0,
      interval: null,
      layananAid: {},
    };
  },
  watch: {
    sw: {
      handler: function (v, o) {
        if (v) {
          this.getLayananAid();
          this.runTImer(this.tl);
        }
        if (o) {
          this.stopTimer();
        }
      },
    },
  },
  methods: {
    stopTimer() {
      clearInterval(this.interval);
    },

    runTImer(timeLeft) {
      this.time = timeLeft;
      this.interval = setInterval(() => {
        if (this.time > 0) {
          this.time -= 1000;
        } else {
          this.stopTimer();
        }
      }, 1000);
    },

    moreAction(id) {
      if (!this.more) {
        this.more = id;
      } else {
        this.more = false;
      }
    },

    async getLayananAid() {
      if (this.aid && this.aid !== "BOS" && this.aid !== "") {
        const res = await this.$store.dispatch(
          "snapMesinModule/fetchLayananByAid",
          this.aid
        );
        this.layananAid = res;
      }
    },

    toDetailMesin() {
      this.$router.push({
        name: "SnapMesinDetail",
        query: {
          idsnap_mesin: this.idMesin,
          idoutlet: this.$route.query.idoutlet,
        },
      });
    },

    toEdit() {
      this.$router.push({
        name: "SnapMesinEdit",
        params: {
          idmesin: this.idMesin,
        },
        query: {
          idoutlet: this.$route.query.idoutlet,
          from: "list",
        },
      });
    },
  },

  mounted() {
    this.getLayananAid();
    if (this.sw) {
      this.runTImer(this.tl);
    }
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  computed: {
    ...mapGetters("snapMesinModule", {
      layananByAid: "getLayananByAid",
    }),
  },
};
</script>

<style scoped>
.card-mesin-snap-list {
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 34, 119, 0.06);
  border-radius: 5px;
  margin-bottom: 12px;

  position: relative;
}

.container-card-header {
  padding: 4px 18px;
  display: flex;
  justify-content: space-between;
}

.item-header-card-mesin {
  display: flex;
  align-items: center;
  width: 50%;
}

.item-header-card-mesin:nth-child(2) {
  justify-content: flex-end;
}

.bg-good {
  background: linear-gradient(90deg, #effaf1 0%, #ffffff 100%), #ffffff;
}

.bg-ok {
  background: linear-gradient(90deg, #fff8e1 0%, #ffffff 100%), #ffffff;
}

.bg-bad {
  background: linear-gradient(90deg, #ffe6e6 0%, #ffffff 50%), #ffffff;
}

.card-mesin-body {
  padding: 10px 18px;
}

.item-card-mesin-body:not(:nth-child(2)) {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-mesin-footer {
  padding: 8px 18px;
  border-top: 1px solid #ededed;
}

.footer-item-running {
  display: flex;
  justify-content: space-between;
  margin-top: 2px;
}

.card-mesin-gray-frame {
  background: #f2f5f7;
  border-radius: 3px;
  padding: 0 4px;
}

.more-menu-card {
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 3px;

  position: absolute;
  top: 0;
  right: 0;
	z-index:99;
}

.more-menu-item {
  padding: 8px 12px;
  display: flex;
  align-content: center;

  border-bottom: 1px solid #ededed;
}

.icon-more-item {
  height: 20px;
  width: 24px;

  margin-right: 8px;
}
</style>